// extracted by mini-css-extract-plugin
module.exports = {"sliderButton":"sliderButton_3HdTce","arrow":"arrow_2UQE1y","arrowRight":"arrowRight_3zI2n4 arrow_2UQE1y","arrowLeft":"arrowLeft_3-qnaE arrow_2UQE1y"};